import React from "react";
import { PortfolioCode } from "./Allcomponents";
import "./index.css";
export default function Portfolio() {
  return (
    <div>
      <PortfolioCode
        heading="portfolio"
        main_heading="Projects Designs"
        main_para="You can find several product design by our professional team in this
      section."
      />
    </div>
  );
}
